import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { teamSchema } from "./schema";
import { fetchTeamData } from "./read";
import { useUpdateTeam } from "../update/mutation";
import { useCreateTeam } from "../create/mutation";

export const useTeamForm = ({ teamId }) => {
  const form = useForm({
    resolver: zodResolver(teamSchema),
    defaultValues: {
      department: "",
      lead: "",
      employees: [],
    },
  });

  const updateTeam = useUpdateTeam();
  const createTeam = useCreateTeam();

  const handleCreate = async (context) => {
    const item = context.values;
    await createTeam.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateTeam.mutateAsync({ teamId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchTeamData({ teamId: id });
    // Transform the data to match the form schema
    return {
      ...response,
      department: response.department?.id || response.department,
      employees: response.employees?.map(emp => emp.employee) || [],
    };
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
